import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon from '@cobliteam/ui/icons';

interface TailwindIndicatorProps {
  onClose: () => void;
}

const BREAKPOINTS = [
  { label: '< mobile', className: 'block mobile:hidden' },
  { label: 'mobile', className: 'hidden mobile:block tablet:hidden' },
  { label: 'tablet', className: 'hidden tablet:block laptop:hidden' },
  { label: 'laptop', className: 'hidden laptop:block desktop:hidden' },
  { label: 'desktop', className: 'hidden desktop:block widescreen:hidden' },
  { label: 'widescreen', className: 'hidden widescreen:block' },
];

/**
 * Visibility is owned by the parent, so this no longer takes an `open` prop it
 * only used to early-return on.
 */
const TailwindIndicator = ({ onClose }: TailwindIndicatorProps) => (
  <div className='flex h-8 items-center gap-1.5 rounded-lg border border-gray-6 bg-white px-2 font-medium font-mono text-gray-12 text-xs shadow-sm'>
    <Tooltip content='Breakpoint atual — redimensione a janela para acompanhar.' asChild>
      <span>
        {BREAKPOINTS.map(({ label, className }) => (
          <span key={label} className={className}>
            {label}
          </span>
        ))}
      </span>
    </Tooltip>
    <button
      type='button'
      onClick={onClose}
      aria-label='Fechar indicador de breakpoint'
      className='rounded p-0.5 text-gray-9 transition-colors hover:bg-gray-3 hover:text-gray-12 focus-visible:outline-2 focus-visible:outline-primary'
    >
      <Icon name='x' size='xs' />
    </button>
  </div>
);

export default TailwindIndicator;
